import type { SxProps, Theme } from "@mui/material/styles";

/** Outer wrapper for AI / Manual impact assessment filter bars. */
export const assessmentCenterFilterBarRootSx: SxProps<Theme> = {
  display: "flex",
  gap: 2,
  mb: 3,
  alignItems: "center",
  flexWrap: "nowrap",
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  boxSizing: "border-box",
  py: "4px",
};

/**
 * Top padding for filter bars with horizontal scroll. Outlined MUI labels float above
 * the field; `overflow-x: auto` forces overflow-y to clip, so labels need room inside.
 */
export const assessmentCenterFilterBarOverflowSx: SxProps<Theme> = {
  overflowX: "auto",
  pt: 1,
  pb: 0.5,
  boxSizing: "border-box",
};

/** Scrollable filter row inside the AI impact assessment filter bar. */
export const assessmentCenterFilterBarScrollSx: SxProps<Theme> = {
  display: "flex",
  gap: 2,
  alignItems: "center",
  flexWrap: "nowrap",
  flex: "1 1 auto",
  minWidth: 0,
  ...assessmentCenterFilterBarOverflowSx,
};

/** Right-aligned actions cluster (refresh, plan management, etc.). */
export const assessmentCenterFilterBarActionsSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  flexShrink: 0,
};

/** Icon button styling for “Get the latest status” refresh control. */
export const assessmentCenterRefreshIconButtonSx: SxProps<Theme> = {
  width: 34,
  height: 34,
  p: 0,
  borderRadius: "4px",
  border: "1px solid rgba(0, 0, 0, 0.1)",
  bgcolor: "#fff",
  "&:hover": {
    bgcolor: "#fff",
  },
  "&.Mui-disabled": {
    bgcolor: "#fff",
    opacity: 0.5,
  },
};

/** Outlined toolbar button used by Plan Management and Process Mapping actions. */
export const assessmentCenterPlansLikeButtonSx: SxProps<Theme> = {
  width: 176,
  height: 32,
  minHeight: 32,
  boxSizing: "border-box",
  gap: "12px",
  px: 1,
  py: 0,
  textTransform: "none",
  fontSize: "0.8125rem",
  fontWeight: 500,
  borderRadius: "6px",
  borderColor: "divider",
  color: "text.primary",
  "& .MuiButton-startIcon": {
    margin: 0,
  },
};
